const MOTION = {
  duration: {
    feedback: 110,
    state: 220,
    route: 260,
    enter: 420,
  },
  easingBezier: {
    outQuart: [0.25, 1, 0.5, 1],
    outExpo: [0.16, 1, 0.3, 1],
    inOut: [0.65, 0, 0.35, 1],
  },
  press: {
    scale: 0.985,
  },
  stack: {
    animation: 'fade_from_bottom' as const,
    animationDuration: 260,
  },
} as const;

export { MOTION };
